export enum ActionStatusEnum {
    PENDING = 'PENDING',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    ERROR = 'ERROR',
    DEFERRED = 'DEFERRED',
    PARTIAL = 'PARTIAL'
}
